module.exports = __webpack_public_path__ + "fonts/Manrope-800-cyrillic-ext25.64f66ba.woff2";